// Pure utility functions for SpecCards

import { faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { cleanPID, fullRecipeType } from "../../helpers/utils"
import { add, format } from "date-fns"

export const ROUNDING_FACTOR = 10 // 10 = 1 dp

export const recipesFilteredByType = (types, recipes) => {
  let list = [...recipes]
  if (types === 'R') {
    list = list.filter(r => r.type === 'R')
  }
  else if (types === 'D') {
    list = list.filter(r => r.type === 'D')
  }
  else if (types === 'P') {
    list = list.filter(r => r.type === 'P')
  }
  return list
}

export const recipesFilteredByOthers = (filter, recipes) => {
  let list = [...recipes]
  if (filter === 'I') {
    list = list.filter(r => r.ingredients.length && r.active)
  }
  else if (filter === 'S') {
    list = list.filter(r => r.steps.length && r.active)
  }
  else if (filter === 'V') {
    list = list.filter(r => !r.active)
  }
  else if (filter === 'A') {
    list = list.filter(r => r.active)
  }
  else if (filter === 'X') {
    list = list.filter(r => r.meta.hasWarnings)
  }
  list = list.sort((a, b) => (a.name > b.name ? 1 : -1))
  return list
}

export const isMatch = (recipe, words) => {
  for (let w = 0; w < words.length; w++) {
    const word = words[w].toUpperCase()
    const matched = `${recipe.display_name || ''}`.toUpperCase().includes(word) ||
      `${recipe.name || ''}`.toUpperCase().includes(word) ||
      `${recipe.desc || ''}`.toUpperCase().includes(word) ||
      `${recipe.terms || ''}`.toUpperCase().includes(word)
    if (!matched) return false
  }
  return true
}

export const recipeName = (recipe) => {
  return recipe.display_name || recipe.name
}

export const spaces = (level) => {
  return '\u00A0'.repeat(level * 3)
}

export const arrayOfNums = (x, y) => [...Array(y - x + 1)].map((_, i) => x + i)

export const calculateWarnings = (oldRecipes) => {
  const recipes = [...oldRecipes]

  const correctUnits = ['g', 'ml']
  const portionUnits = ['portion', 'each', 'slices', 'recipe', 'sheet', 'bag', 'box', 'tray', 'containers', 'loaves', 'cake', 'roll']

  recipes.forEach(r => {
    r.meta = {}

    if (r.ingredients?.length) {
      const ingredientTotal = r.ingredients.reduce((acc, i) => acc + (i.quantity), 0)
      const isPortionUnit = portionUnits.includes(r.quantity_unit?.toLowerCase())
      const isValidUnit = correctUnits.includes(r.quantity_unit?.toLowerCase())

      if (r.quantity !== null && !isPortionUnit && !isValidUnit) {
        r.meta.hasWarnings = true
        r.meta.incorrectUnits = r.quantity_unit
      }

      if (r.ingredients?.find(i => !i.quantity_unit)) {
        r.meta.hasWarnings = true
        r.meta.emptyIngredientUnits = true
      }

      if (!isPortionUnit && r.quantity !== null && r.quantity !== ingredientTotal) {
        r.meta.hasWarnings = true
        r.meta.mismatched = true
        r.meta.mismatchedPerc = Math.round(1000 * (ingredientTotal - r.quantity) / r.quantity) / 10
      }
    }
  })

  return recipes
}

export const getCombinedIngredients = (recipes) => {
  const ingredients = []

  recipes.forEach(r => {
    r.ingredients?.forEach(i => {
      const ingredient = i.recipe

      if (ingredient.type !== 'P') return

      const match = ingredients.find(m => m.pid === ingredient.pid && m.quantity_unit === i.quantity_unit)

      if (match) {
        match.quantity_adjusted += i.quantity_adjusted
      }
      else {
        ingredients.push({ ...ingredient, ...i })
      }
    })
  })
  return ingredients
}

export const getRandom = () => {
  return Math.floor(100000 + Math.random() * 899999)
}



export const Allergen = ({ name }) => {
    const label = name === '!' ? <><FontAwesomeIcon icon={faWarning} /> CONFIRM</> : name
    return <div className={`allergen ${name === '!' ? 'confirm-allergen' : ''}`}>{label}</div>
  }

export const Logo = () => {
  return <div className="specCard-logo">
    <img src='/eln-london.png' alt="EL&amp;N London" />

    <div className='specCard-terms'>Property of EL&amp;N LONDON - CONFIDENTIAL</div>
  </div>
}

export const batchNumber = (selectedDate, space, initials, recipe) => {
      return `${initials || `${space}${space}${space}${space}`} - ${format(selectedDate, 'ddMMyyyy')} - ${cleanPID(recipe.pid, recipe.type)}`
    }

export const buildBatchLabel = (selectedDate, recipe, initials, bbeOBJ, allergens, isHTML, chilled) => {
    const newLine = isHTML ? '<br />' : '\n'
    const space = isHTML ? '&nbsp;' : ' '

    let str = `${recipeName(recipe)}${newLine}`
    str += `${fullRecipeType(recipe.type)} ${cleanPID(recipe.pid, recipe.type)}${newLine}`
    str += `Allergens: ${allergens ? allergens.join(', ') : '-'}${newLine}`
    str += `${batchNumber(selectedDate, space, initials, recipe)}${newLine}`
    str += `Best Before: ${format(add(selectedDate, bbeOBJ), 'dd MMM yyyy')} ${chilled}`
    return (str)
  }


export const getAllergensForRecipe = (recipes, recipe) => {

    if (!recipe) return []
    let topArr = recipe.allergens ? recipe.allergens.split(',') : []

    if (recipe.type === 'P' && topArr.length === 0 && !recipe.no_allergens) {
      topArr = ['!'] /* no allergens and not marked as such - flag it up */
    }

    recipe.ingredients?.forEach(i => {

      const ingredient_recipe = recipes.find(r => r.pid === i.child_pid)

      if (ingredient_recipe) {
        const arr = []

        let allergensArray = ingredient_recipe.allergens ? ingredient_recipe.allergens.split(',') : []
        
        if (ingredient_recipe.type === 'P' && allergensArray.length === 0 && !ingredient_recipe.no_allergens) {
          allergensArray = '!' /* no allergens and not marked as such - flag it up */
        }
        arr.push(allergensArray)
        arr.push(getAllergensForRecipe(recipes, ingredient_recipe))
        topArr.push(arr.flat())
      }
    })

    return [...new Set(topArr.flat().filter(Boolean))].sort((a, b) => (a > b ? 1 : -1))
  }


export const showQuantity = (quantity, multiplier, unit) => {
    
    
    let num = Math.floor(ROUNDING_FACTOR * parseFloat(quantity) * parseFloat(multiplier || 1)) / ROUNDING_FACTOR

    // if zero - show to 1 sig fig
    if (num === 0) num = (parseFloat(quantity) * parseFloat(multiplier || 1)).toPrecision(1)
    
    let plural = ''
    if (num > 1 && unit === 'dish') plural = 'es'
    if (num > 1 && unit === 'portion') plural = 's'

    return `${num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${unit}${plural}`
  }
